import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background: #000;
  /* border-radius: 8px; */
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;
